import styled from "styled-components";

export const CollapsibleButtonContainer = styled.div`
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;

  border-radius: 50px;
  background-color: ${({ theme }) => theme.colors.background.info};
  color: #fff;
  padding: 5px;

  &:hover {
    width: auto;
    gap: 10px;
    padding: 5px 5px 5px 15px;

    .info_text {
      opacity: 1;
      width: auto;
      transform: translateX(0);
    }
  }

  .info_text {
    opacity: 0;
    width: 0;
    overflow: hidden;
    transform: translateX(10px);
    transition:
      opacity 0.5s ease,
      width 0.5s ease,
      transform 0.5s ease;
  }
`;
